export default __webpack_public_path__ + "static/media/qmas-logo.b476c5fd.svg";